import { BODY_LG_LG_MEDIUM_STYLES, BODY_SM_SM_MEDIUM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const CardsListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-xs, 8px);
    align-self: stretch;
`;

export const CardDaySeparator = styled.div<{ $isFirstItem?: boolean }>`
    flex: 1 0 0;
    color: var(--colors-text-body, #50566e);
    ${BODY_LG_LG_MEDIUM_STYLES};
    margin-top: ${({ $isFirstItem }) => ($isFirstItem ? 8 : 22)}px;
`;

export const MarkAllAsRead = styled.div`
    color: var(--colors-text-action, #2171c6);
    ${BODY_SM_SM_MEDIUM_STYLES};
    position: absolute;
    right: 0;
    top: 16px;
    cursor: pointer;
`;
